import Swiper, { A11y, Controller } from "swiper";

if(document.querySelectorAll('.vehicle-block').length > 0) {
    Swiper.use([A11y, Controller]);

    const swipers = [];
    document.querySelectorAll('.row.swiper').forEach(swiper => {
        const swiperInstance = new Swiper(swiper, {
            allowTouchMove: true,
            slidesPerView: 1,
            spaceBetween: 5,
            mousewheel: true,
            breakpoints: {
                380: {
                    slidesPerView: 1.5,
                },
                450: {
                    spaceBetween: 10,
                    slidesPerView: 2.2,
                },
                768: {
                    slidesPerView: 3.2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 4.2
                },
                1280: {
                    slidesPerView: 5.2
                }
            }
        });
        swipers.push(swiperInstance);
    });

    let isSyncing = false;

    swipers.forEach((currentSwiper) => {

  // A. Synka själva dragningen (när användaren drar med fingret/musen)
  currentSwiper.on('progress', (swiper, progress) => {
    if (isSyncing) return;
    isSyncing = true;

    swipers.forEach((otherSwiper) => {
      if (otherSwiper !== currentSwiper) {
        // Sätt exakt samma position (progress) på de andra slidersna
        otherSwiper.setProgress(progress);
      }
    });

    isSyncing = false;
  });

  // B. Synka animationshastigheten (så att släppet/glidet sker samtidigt)
  currentSwiper.on('setTransition', (swiper, duration) => {
    if (isSyncing) return;
    isSyncing = true;

    swipers.forEach((otherSwiper) => {
      if (otherSwiper !== currentSwiper) {
        // Ge alla andra sliders exakt samma animationstid
        otherSwiper.setTransition(duration);
      }
    });

    isSyncing = false;
  });
    });

    updateTable();
    window.addEventListener('compare-update', updateTable);

    document.querySelectorAll('.row-opener').forEach(button => {
        button.addEventListener('click', () => {
            button.parentElement.parentElement.classList.toggle('openable--open')
        });
    });

    if (document.querySelector('.show-comparison')) {
        document.querySelector('.show-comparison').addEventListener('click', () => {
            document.querySelector('.vehicle-compare-modal__bg').removeAttribute('inert');
            document.querySelector('.vehicle-compare-modal__bg').classList.add('vehicle-compare-modal__bg--active');
            document.querySelector('.vehicle-compare-modal__sharer').focus();
        });
    }

    if (document.querySelector('.vehicle-compare-modal__dim')) {
        document.querySelector('.vehicle-compare-modal__dim').addEventListener('click', () => {
            document.querySelector('.vehicle-compare-modal__bg').setAttribute('inert', '');
            document.querySelector('.vehicle-compare-modal__bg').classList.remove('vehicle-compare-modal__bg--active')
            document.querySelector('.show-comparison').focus();
        });
    }

    if (document.querySelector('.clear-comparison')) {
        document.querySelector('.clear-comparison').addEventListener('click', () => {
            document.querySelector('.vehicle-compare-modal__bg').classList.remove('vehicle-compare-modal__bg--active')
            document.querySelector('.vehicle-compare-modal__bg').setAttribute('inert', '');
            document.querySelector('.show-comparison').focus();

            let vehicles = getCookies().split('|');

            vehicles.forEach(vehicle => {
                removeCookie(vehicle);
            });

            clearTable();
            window.dispatchEvent(new Event('compare-update'));
        });
    }

    if (document.querySelector('.vehicle-compare-modal__sharer')) {
        document.querySelector('.vehicle-compare-modal__sharer').addEventListener('click', async e => {
          const shareData = {
            title: 'Landrins Bil - Jämför bilar till salu',
            // text: e.srcElement.dataset.text,
            url: getShareUrl(),
          };
          try {
            await navigator.share(shareData);
          } catch (err) {
            console.error(`Error: ${err}`)
          }
        });
    }

    if (document.querySelector('.vehicle-compare-modal__closer')) {
        document.querySelector('.vehicle-compare-modal__closer').addEventListener('click', () => {
            document.querySelector('.vehicle-compare-modal__bg').classList.remove('vehicle-compare-modal__bg--active')
            document.querySelector('.vehicle-compare-modal__bg').setAttribute('inert', '');
            document.querySelector('.show-comparison').focus();
        });
    }
}

function getShareUrl() {
    const vehicles = getCookies().replaceAll('|', ',');

    const url = new URL(window.location.href);
    url.searchParams.set('compare', vehicles);

    return url.toString();
}

function updateTable() {
    if (typeof swipers !== 'undefined') {
        swipers.forEach(swiper => swiper.update());
    }

    let vehicles = getCookies().split('|');

    let url = new URL(window.location.href).searchParams.get('compare');
    if (url) {
        vehicles = url.split(',');

        const date = new Date();
        date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
        document.cookie = "compare-vehicles=" + vehicles.join('|') + "; expires=" + date.toGMTString() + "; path=/";

        setTimeout(() => {
            document.querySelector('.vehicle-compare-modal__bg').removeAttribute('inert');
            document.querySelector('.vehicle-compare-modal__bg').classList.add('vehicle-compare-modal__bg--active');
            document.querySelector('.vehicle-compare-modal__sharer').focus();
        }, 1000);

        url = new URL(window.location.href);
        url.searchParams.delete('compare');
        window.history.replaceState(null, null, url);
    }

    if (document.querySelector('.vehicle-compare-bar')) {
        if (vehicles.filter(v => v).length > 0) {
            document.querySelector('.vehicle-compare-bar').classList.add('vehicle-compare-bar--active');

            document.querySelector('.vehicle-compare-bar__count').textContent = vehicles.filter(v => v).length;
        } else {
            document.querySelector('.vehicle-compare-bar').classList.remove('vehicle-compare-bar--active');
        }
    }

    clearTable();

    document.querySelectorAll('.compare-button--active').forEach(button => {
        const id = button.getAttribute('data-vehicle-id');
        if(!vehicles.includes(id)) {
            button.classList.remove('compare-button--active');
        }
    });

    fetchVehicles(vehicles);
}

async function fetchVehicles(vehicles) {
    const form = new FormData();
    form.append('action', 'nobox_get_vehicle');
    form.append('vehicles', vehicles);
    const params = new URLSearchParams(form);

    vehicles.forEach(vehicle => {
        if (document.querySelector('.compare-button[data-vehicle-id="' + vehicle + '"]')) {
            document.querySelector('.compare-button[data-vehicle-id="' + vehicle + '"]').classList.add('compare-button--active');
        }
    });

    await fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        if (!data.data) return;

        const vehicles = data.data.result;

        const minPrice = vehicles.reduce((prev, curr) => parseInt(prev.price) < parseInt(curr.price) ? prev : curr);
        const minMileage = vehicles.reduce((prev, curr) => parseInt(prev.miles) < parseInt(curr.miles) ? prev : curr);
        const newest = vehicles.reduce((prev, curr) => parseInt(prev.model_year) > parseInt(curr.model_year) ? prev : curr);
        const maxHp = vehicles.reduce((prev, curr) => parseInt(prev.horsepower) > parseInt(curr.horsepower) ? prev : curr);

        vehicles.filter((vehicle) => vehicle.price === minPrice.price).forEach((vehicle) => vehicle.minPrice = true);
        vehicles.filter((vehicle) => vehicle.miles === minMileage.miles).forEach((vehicle) => vehicle.minMiles = true);
        vehicles.filter((vehicle) => vehicle.model_year === newest.model_year).forEach((vehicle) => vehicle.newest = true);
        vehicles.filter((vehicle) => vehicle.horsepower === maxHp.horsepower).forEach((vehicle) => vehicle.maxHp = true);

        vehicles.forEach(vehicle => {
            addVehicleToTable(vehicle);
        });
    })

    lockMovers();
}

function clearTable() {
    const tds = document.querySelectorAll('.vehicle-compare-modal__table .row .cell');
    tds.forEach(td => td.remove());
}

function addVehicleToTable(vehicle) {
    if (!vehicle) return;

    const table_body = document.querySelector('.vehicle-compare-modal__table');
    const rows = table_body.querySelectorAll('.row .content');
    const name = '<p class="name">' + vehicle.brand + ' ' + vehicle.model + '</p>';
    const desc = '<p class="desc">' + vehicle.model_description + '</p>';
    const more = '<p class="more">Läs mer</p>';
    const a = '<a href="'+ vehicle.url +'" class="link"></a>';

    const remover = document.createElement('button');
    remover.classList.add('vehicle-compare-modal__vehicle-remover');
    remover.innerHTML = '<i class="far fa-times"></i>';
    remover.setAttribute('data-id', vehicle.id);
    remover.setAttribute('aria-label', 'Ta bort fordon');
    remover.addEventListener('click', () => {
        const id = remover.getAttribute('data-id');
        removeCookie(id);
        document.querySelectorAll('.cell[data-vehicle-id="' + id + '"]').forEach(td => td.remove());

        let vehicles = getCookies().split('|');

        if (vehicles.filter(v => v).length > 0) {
            document.querySelector('.vehicle-compare-bar').classList.add('vehicle-compare-bar--active');
            document.querySelector('.vehicle-compare-bar__count').textContent = vehicles.filter(v => v).length;
        } else {
            document.querySelector('.vehicle-compare-modal__bg').classList.remove('vehicle-compare-modal__bg--active');
            document.querySelector('.vehicle-compare-modal__bg').setAttribute('inert', '');
            document.querySelector('.show-comparison').focus();
            document.querySelector('.vehicle-compare-bar').classList.remove('vehicle-compare-bar--active');
        }

        document.querySelectorAll('.compare-button--active').forEach(button => {
            if(!vehicles.includes(button.getAttribute('data-vehicle-id'))) {
                button.classList.remove('compare-button--active');
            }
        });

        lockMovers();
    });

    const mover_right = document.createElement('button');
    mover_right.classList.add('vehicle-compare-modal__vehicle-mover', 'vehicle-compare-modal__vehicle-mover--right');
    mover_right.innerHTML = '<i class="fal fa-angle-right"></i>';
    mover_right.setAttribute('data-id', vehicle.id);
    mover_right.setAttribute('aria-label', 'Flytta fordon till höger');
    mover_right.addEventListener('click', () => {
        moveIdInCookie(vehicle.id, 'right');
        const cells = document.querySelectorAll('.vehicle-compare-modal__table-cell[data-vehicle-id="' + vehicle.id + '"]');

        cells.forEach(cell => {
            if (cell.nextElementSibling && cell.nextElementSibling.nextElementSibling) {
                cell.parentElement.insertBefore(cell, cell.nextElementSibling.nextElementSibling);
            } else if (cell.nextElementSibling) {
                cell.parentElement.appendChild(cell);
            }
        });
        lockMovers();
    });

    const mover_left = document.createElement('button');
    mover_left.classList.add('vehicle-compare-modal__vehicle-mover', 'vehicle-compare-modal__vehicle-mover--left');
    mover_left.innerHTML = '<i class="fal fa-angle-left"></i>';
    mover_left.setAttribute('data-id', vehicle.id);
    mover_left.setAttribute('aria-label', 'Flytta fordon till vänster');
    mover_left.addEventListener('click', () => {
        console.log('123')
        moveIdInCookie(vehicle.id, 'left');
        const cells = document.querySelectorAll('.vehicle-compare-modal__table-cell[data-vehicle-id="' + vehicle.id + '"]');

        cells.forEach(cell => {
            if (cell.previousElementSibling) {
                cell.parentElement.insertBefore(cell, cell.previousElementSibling);
            }
        });
        lockMovers();
    });

    let td = document.createElement('div');
    if (JSON.parse(vehicle.images).length > 0) {
        td.innerHTML = '<img alt="Bild på en '+ vehicle.brand + ' ' + vehicle.model + '" src="' + JSON.parse(vehicle.images)[0].url + '" />';
    } else {
        td.innerHTML = '<img alt="Platshållarbild för en '+ vehicle.brand + ' ' + vehicle.model + '" src="https://landrinsbil.se/app/themes/landrins-theme/assets/images/noimage-small.webp" />';
    }
    td.innerHTML += name + desc + more + a;
    td.appendChild(mover_left);
    td.appendChild(mover_right);
    td.appendChild(remover);
    td.classList.add('swiper-slide', 'cell', 'vehicle-compare-modal__table-cell', 'vehicle-compare-modal__table-cell--image');
    td.setAttribute('data-vehicle-id', vehicle.id);

    const attrs = [
        '<p class="cell swiper-slide vehicle-compare-modal__table-cell vehicle-compare-modal__table-cell--other" data-vehicle-id="' + vehicle.id + '">' +
            '<span>Pris</span><strong class="'+ (vehicle.minPrice ? ' vehicle-compare-modal__table-cell--highlight' : '') +'">' + Math.round(parseFloat(getPrice(vehicle))).toLocaleString("sv").replace("−", "− ") + 'kr</strong>' +
            '<span>År</span><strong class="'+ (vehicle.newest ? ' vehicle-compare-modal__table-cell--highlight' : '') +'">' + vehicle.model_year + '</strong>' +
            '<span>Miltal</span><strong class="'+ (vehicle.minMiles ? ' vehicle-compare-modal__table-cell--highlight' : '') +'">' + Math.round(parseFloat(vehicle.miles)).toLocaleString("sv").replace("−", "− ") + '</strong>' +
            '<span>Bränsle</span><strong>' + vehicle.fuel_type + '</strong>' +
            '<span>Hjuldrift</span><strong>' + (vehicle.four_wheel_drive === '1' ? 'Fyrhjulsdrift' : 'Tvåhjulsdrift') + '</strong>' +
            '<span>Växellåda</span><strong>' + vehicle.gearbox_type + '</strong>' +
            '<span>Hästkrafter</span><strong class="'+(vehicle.maxHp ? ' vehicle-compare-modal__table-cell--highlight' : '')+'">' + vehicle.horsepower + '</strong>' +
            '<span>Dragkrok</span><strong>' + (vehicle.towbar === '1' ? 'Ja' : 'Nej') + '</strong>' +
        '</p>',
        '<ul class="checkmarks cell swiper-slide vehicle-compare-modal__table-cell vehicle-compare-modal__table-cell--highlights" data-vehicle-id="' + vehicle.id + '">' +
            (vehicle.highlights && vehicle.highlights.length > 1 ? '<li>' + vehicle.highlights.sort().join('</li><li>') + '</li>' : '') +
        '</ul>',
        '<p class="cell swiper-slide vehicle-compare-modal__table-cell vehicle-compare-modal__table-cell--other" data-vehicle-id="' + vehicle.id + '">' +
            '<span>Registreringsnummer</span><strong>' + vehicle.reg_number + '</strong>' +
            '<span>Fordonstyp</span><strong>' + vehicle.vehicle_type + '</strong>' +
            '<span>Märke</span><strong>' + vehicle.brand + '</strong>' +
            '<span>Modell</span><strong>' + vehicle.model + '</strong>' +
            '<span>Stad</span><strong>' + vehicle.city + '</strong>' +
        '</p>'
    ];

    rows[0].appendChild(td);
    attrs.forEach((attr, index) => {
        rows[index + 1].insertAdjacentHTML('beforeend', attr);
    });
}

function getColorText(vehicle) {
    if(vehicle.color_group === vehicle.color)
        return vehicle.color_group;

    if(vehicle.color_group === 'Övrigt')
        return vehicle.color;


    return vehicle.color_group + ' (' + vehicle.color + ')';
}

function lockMovers() {
    document.querySelectorAll('.vehicle-compare-modal__vehicle-mover--disabled').forEach(mover => {
        mover.classList.remove('vehicle-compare-modal__vehicle-mover--disabled');
        mover.disabled = false;
    });

    const cells = document.querySelectorAll('.vehicle-compare-modal__table .row:first-child .vehicle-compare-modal__table-cell');
    if (cells && cells[0]) {
        cells[0].querySelector('.vehicle-compare-modal__vehicle-mover--left').disabled = true;
        cells[0].querySelector('.vehicle-compare-modal__vehicle-mover--left').classList.add('vehicle-compare-modal__vehicle-mover--disabled');
        cells[cells.length - 1].querySelector('.vehicle-compare-modal__vehicle-mover--right').disabled = true;
        cells[cells.length - 1].querySelector('.vehicle-compare-modal__vehicle-mover--right').classList.add('vehicle-compare-modal__vehicle-mover--disabled');

    }
}

function moveIdInCookie(id, direction) {
    const cookies = getCookies();
    const ids = cookies ? cookies.split('|') : [];
    const index = ids.indexOf(id);
    if (index !== -1) {
        const item = ids[index];
        ids.splice(index, 1);
        if (direction === 'right') {
            ids.splice(index+1, 0, item);
        } else if (direction === 'left') {
            ids.splice(index-1, 0, item);
        }
    }

    const date = new Date();
    date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
    document.cookie = "compare-vehicles=" + ids.join('|') + "; expires=" + date.toGMTString() + "; path=/";

    return ids;
}

function getPrice(vehicle) {
    if (vehicle.vehicle_type == "Personbil" && vehicle.price_vat) {
        return vehicle.price_discounted ? vehicle.price_discounted : vehicle.price;
    } else if (vehicle.vehicle_type == "Transportbil" && vehicle.price_vat) {
        return vehicle.price_discounted ? vehicle.price_discounted * 0.8 : vehicle.price * 0.8;
    } else {
        return vehicle.price_discounted ? vehicle.price_discounted : vehicle.price;
    }
}

function getCookies() {
    const cookies = decodeURIComponent(document.cookie);
    const name = "compare-vehicles=";
    let ca = cookies.split(";");

    let value = "";

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            value = c.substring(name.length, c.length);
        }
    }

    return value;
}

function removeCookie(vehicleId) {
    if (!vehicleId) {
        return;
    }

    const date = new Date();
    date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);

    const values = (getCookies() ? getCookies() : "");
    let arr = values.split('|');

    if(arr.includes(vehicleId)) {
        arr.splice(arr.indexOf(vehicleId), 1);
    }
    arr = arr.filter((v) => v);

    document.cookie = "compare-vehicles=" + arr.join('|') + "; expires=" + date.toGMTString() + "; path=/";
}
